import * as React from "react";
const SvgFiBrandsIncopy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-incopy_svg__a)">
      <path
        fill="#151A2D"
        d="M19.751.428H4.249A4.25 4.25 0 0 0 0 4.678v14.645a4.25 4.25 0 0 0 4.249 4.25h15.502A4.25 4.25 0 0 0 24 19.322V4.677A4.25 4.25 0 0 0 19.751.428M9.786 6.562V16.5q0 .16-.143.16l-1.785.028q-.127 0-.127-.159V6.592q0-.127.143-.127l1.785-.03a.114.114 0 0 1 .127.127m7.359 9.931a.16.16 0 0 1-.08.143 2.4 2.4 0 0 1-.736.191 9 9 0 0 1-.92.047c-.6.01-1.197-.092-1.76-.3-.979-.364-1.775-1.19-2.149-2.158-.464-1.2-.389-2.619.262-3.734.788-1.349 2.397-2.04 3.917-2.006a6 6 0 0 1 .936.056q.223.039.435.12a.19.19 0 0 1 .08.173l-.016 1.672q0 .143-.127.111a1.7 1.7 0 0 0-.435-.135 5 5 0 0 0-.793-.056 2.8 2.8 0 0 0-1.173.2 1.87 1.87 0 0 0-.825.713 2.2 2.2 0 0 0-.301 1.205c-.026.461.1.917.357 1.301.227.31.542.544.904.674.353.13.726.197 1.102.198q.381.002.761-.04.224-.021.435-.103.127-.03.127.095z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-incopy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsIncopy;
